import { lazy } from "react";
const OtTradeConfirmBase = lazy(() => import("app/pages/ot/tradeConfirm/list/TradeConfirmBase"));
const OtMyDeals = lazy(() => import("app/pages/ot/myDeal/MyDeals"));
const OtRecMarket = lazy(() => import("app/pages/ot/market/RecMarket"));
const OtTradeConfirmBoardDetail = lazy(() => import("app/pages/ot/tradeConfirm/detail/TradeConfirmBoardDetail"));
const OtTradeConfirmApplyDetail = lazy(() => import("app/pages/ot/tradeConfirm/detail/TradeConfirmApplyDetail"));
const ContractListBase = lazy(() => import("app/pages/cb/contractList/ContractListBase"));
const ContractList = lazy(() => import("app/pages/cb/contractList/ContractList"));
const BillListBase = lazy(() => import("app/pages/cb/billList/BillListBase"));
const BillFormBase = lazy(() => import("app/pages/cb/billForm/BillFormBase"));
const BillDetailBase = lazy(() => import("app/pages/cb/billDetail/BillDetailBase"));
const BillFormModify = lazy(() => import("app/pages/cb/billForm/BillFormModify"));

const TradeContractForm = lazy(() => import("app/pages/cb/contractForm/ContractFormBase"));
const TradeContractDetail = lazy(() => import("app/pages/cb/contractDetail/ContractDetailBase"));
const TradeRpdc = lazy(() => import("app/pages/ot/tradeRpdc/TradeRpdc"));
const TradeRpdcForm = lazy(() => import("app/pages/ot/tradeRpdc/TradeRpdcForm"));
const TradeRpdcDetail = lazy(() => import("app/pages/ot/tradeRpdc/TradeRpdcDetail"))

export const otRouter: any = [
  // 에너지마켓 장외거래
  // 새 구성(시세 요약 → 게시판 → 시세 추이). 기존 /ot/rec/trade 는 그대로 둔다
  { path: '/ot/rec/market', element: <OtRecMarket />, },

  // 에너지마켓 장외거래 - confirm
  { path: '/ot/rec/contract', element: <OtMyDeals /> },
  { path: '/ot/rec/contract/list', element: <OtTradeConfirmBase /> },
  { path: '/ot/rec/contract/board/detail', element: <OtTradeConfirmBoardDetail /> },
  { path: '/ot/rec/contract/apply/detail', element: <OtTradeConfirmApplyDetail /> },

  // 에너지마켓 계약관리
  // 새 구성. 예전 목록은 /ot/contract/list 로 남긴다
  { path: '/ot/contract', element: <ContractList /> },
  { path: '/ot/contract/list', element: <ContractListBase /> },
  { path: '/ot/contract/form', element: <TradeContractForm /> },
  { path: '/ot/contract/detail', element: <TradeContractDetail /> },

  // 에너지마켓 유연자원시장 거래 현황

  // 에너지마켓 유연자원시장 이력관리

  // 에너지마켓 부정거래 신고
  { path: '/ot/trade/rpdcs', element: <TradeRpdc /> },
  { path: '/ot/trade/rpdcs/form', element: <TradeRpdcForm /> },
  { path: '/ot/trade/rpdcs/detail', element: <TradeRpdcDetail /> },

  // 에너지마켓 정산조정 신청

  // 에너지마켓 공증기관 정보

  // 에너지마켓 정산관리
  { path: '/ot/bill', element: <BillListBase /> },
  { path: '/ot/bill/form', element: <BillFormBase /> },
  { path: '/ot/bill/modify', element: <BillFormModify /> },
  { path: '/ot/bill/detail', element: <BillDetailBase /> },
];